import React from 'react';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverrideLite';
import { FDBodyText } from '@facet-wealth/design';
import { buildBaseOverrides } from 'Components/UI/guidedHouseholdReview/baseOverrides';
import { Text } from 'Packages/FacetDesign/Components/Text';

export const linterResultMetaOverrideSet = buildBaseOverrides()
  .nameOverride('text', {
    _component: () => Text,
    _customProps: { Component: FDBodyText, size: 'md' },
  }, overrideReadOnly);

export const PM2JourneyPathExplorerExitLinterResult = () => {
  const { resource } = useMetaLayoutContext();
  if (resource.attr('text') === '' && resource.attr('richText') === '') {
    return null;
  }

  return (
    <li>
      {resource.attr('text') !== '' && <MetaControlField attr={'text'} />}
      {resource.attr('richText') !== '' && <MetaControlField attr={'richText'} />}
    </li>
  );
};
